// An input component that implements async autocomplete via an API endpoint
// using react-autosuggest (https://github.com/moroshko/react-autosuggest)
// This is a fully controlled component and requires its parent to manage its
// state, see propTypes for what's needed
import React, { useState } from "react";
import PropTypes from "prop-types";
import Autosuggest from "react-autosuggest";

import LabelContainer from "components/shared/LabelContainer";

function getSuggestionValue(suggestion) {
  return suggestion.text;
}

function renderSuggestion(suggestion) {
  return <span>{suggestion.text}</span>;
}

const propTypes = {
  // See https://github.com/moroshko/react-autosuggest#inputpropsonchange-required for api
  handleChange: PropTypes.func.isRequired,
  labelText: PropTypes.string,
  name: PropTypes.string.isRequired,
  // See https://github.com/moroshko/react-autosuggest#on-suggestion-selected-prop for api
  onSuggestionSelect: PropTypes.func.isRequired,
  suggestionUrl: PropTypes.string.isRequired,
  value: PropTypes.string
};

const defaultProps = {
  labelText: "",
  value: ""
};

const AutocompleteInput = (props) => {
  const [suggestions, setSuggestions] = useState([]);

  const loadSuggestions = async (val) => {
    const results = await $.get(`${props.suggestionUrl}${val}`);
    setSuggestions(results.data);
  };

  function onSuggestionsFetchRequested({ value }) {
    loadSuggestions(value);
  }

  function onSuggestionsClearRequested() {
    setSuggestions([]);
  }

  function onSuggestionSelected(e, { suggestion }) {
    props.onSuggestionSelect(suggestion);
  }

  // We don't use our Input component here because react-autosuggest requires
  // some trickery with ref passing if we use a component and using an <input />
  // is much easier
  function renderInput(inputProps) {
    return (
      <div className="input-container">
        <LabelContainer labelText={props.labelText} />
        <input {...inputProps} className="input-md" name={props.name} />
      </div>
    );
  }

  return (
    <Autosuggest
      suggestions={suggestions}
      onSuggestionsFetchRequested={onSuggestionsFetchRequested}
      onSuggestionsClearRequested={onSuggestionsClearRequested}
      getSuggestionValue={getSuggestionValue}
      onSuggestionSelected={onSuggestionSelected}
      renderSuggestion={renderSuggestion}
      renderInputComponent={renderInput}
      inputProps={{ onChange: props.handleChange, value: props.value }}
    />
  );
};

AutocompleteInput.propTypes = propTypes;
AutocompleteInput.defaultProps = defaultProps;

export default AutocompleteInput;
